import { gql } from 'apollo-boost';

export const FIND_ALL_QUERY = gql`
    {
        findAll {
            id,
            modelDate,
            createdBy,
            createdFor,
            testName,
            description,
            mediaVolume,
            mediaFinalConcentration,
            dispensingFlowRate,
            temperature,
            priorityMode
        } 
    }`;

export const LOGIN_QUERY = gql`
    query LoginDetails($logonId: String!, $password: String!, $isCent: Boolean!, $isRememberMe: Boolean!, $userTokenId: String!, $sTokenId: String!, $isEncrypted: Boolean) {
        login(input: {logonId: $logonId, password: $password, isCent:$isCent, isRememberMe: $isRememberMe, userTokenId:$userTokenId, sTokenId:$sTokenId, isEncrypted:$isEncrypted}) {
            token
			msg
        }
    }
`;

export const REGISTER_QUERY = gql`
    query registrationDetails($firstName: String!, $lastName: String!, $country: String!, $logonId: String!, $password: String!, $registerOrg: String!) {
        registration(input: {firstName: $firstName, lastName: $lastName, country:$country, logonId: $logonId, password:$password, registerOrg:$registerOrg}) {
            msg
            code
        }
    }
`;

export const GET_TOKEN_QUERY = gql`
    {
        getToken {
            token
        }
    }
`;

export const FIND_BY_ID_QUERY = gql`
    query findAllById($id: ID!) {
        findById(id: $id) {
            id,
            modelDate,
            createdBy,
            testName,
            description,
            mediaVolume,
            mediaFinalConcentration,
            dispensingFlowRate,
            temperature,
            priorityMode,
            createdFor
        } 
    }
`;
export const CREATE_TEST_QUERY = gql`
    mutation createTestDataForm($instrumentVersion: String!, $testName: String!, $modelDate: String!, $description: String!, $mediaVolume: Int!, $mediaFinalConcentration: Float!, $dispensingFlowRate: Float!, $temperature: Int, $priorityMode: String) {
        createTestData(input: {instrumentVersion: $instrumentVersion, testName: $testName, modelDate: $modelDate, description: $description, mediaVolume: $mediaVolume, mediaFinalConcentration: $mediaFinalConcentration, dispensingFlowRate: $dispensingFlowRate, temperature: $temperature, priorityMode: $priorityMode }) {
            id
            instrumentVersion
            testName
            modelDate
            description
            mediaVolume
            mediaFinalConcentration
            dispensingFlowRate
            temperature
            priorityMode
        }
    }
`;
export const UPDATE_TEST_QUERY = gql`
    mutation updateTestDataForm($id: Int!, $status: Boolean!, $instrumentVersion: String!, $testName: String!, $modelDate: String!, $description: String!, $mediaVolume: Int!, $mediaFinalConcentration: Float!, $dispensingFlowRate: Float!, $temperature: Int, $priorityMode: String) {
        updateTestData(input: {id: $id, status: $status, instrumentVersion: $instrumentVersion, testName: $testName, modelDate: $modelDate, description: $description, mediaVolume: $mediaVolume, mediaFinalConcentration: $mediaFinalConcentration, dispensingFlowRate: $dispensingFlowRate, temperature: $temperature, priorityMode: $priorityMode}) {
            id
            instrumentVersion
            testName
            modelDate
            description
            mediaVolume
            mediaFinalConcentration
            dispensingFlowRate
            temperature
            priorityMode
        }
    }
`;
export const DELETE_TEST_QUERY = gql`
    mutation deleteTestDataForm($id: [Int!]) {
        deleteTestData(input: $id) {
            id
            instrumentVersion
            testName
            modelDate
            createdBy
            createdFor
            description
            mediaVolume
            mediaFinalConcentration
            dispensingFlowRate
            temperature
            priorityMode
        }
    }
`;

export const GET_USER_QUERY = gql`
    query getUserById($id: String!) {
        user(input: {
            logonId: $id
        }){
            id
            userId
            logonId
            firstName
            lastName
            registrationDate
            organization
            registrationStatus
            approvedBy
            country
            userStatus
            accessToken
            validateEmail
        } 
    }
`;

export const UPDATE_USER_QUERY = gql`
    query updateUser($id: Int!, $firstName: String!, $lastName: String!, $country: String!, $organization: String!) {
        updateProfile(input: { id: $id, firstName: $firstName, lastName: $lastName, country: $country, organization: $organization }) {
            msg
        } 
    }
`;

export const GET_CAPTCHA = gql`
    query getCAptcha {
        captcha {
            image
            value
        }
    }
`
export const UPDATE_PASSWORD = gql`
    mutation updatePassword($password: String!, $newPassword: String!, $userId: String!) {
        changePassword(input: {
        newPassword: $newPassword,
        password: $password,
        userId: $userId
        }) {
            msg
            statusCode
        }
    }
`;

export const FORGOT_PASSWORD_QUERY = gql`
    query forgotPasswordQuery($email: String!) {
        forgotPassword(input: {email: $email}){
            msg
            statusCode
        }
    }
`;

export const RESET_PASSWORD = gql`
    mutation resetPasswordDetails($password: String!, $confirmPassword: String!, $accessToken: String!) {
        resetPassword(input: {password: $password, confirmPassword: $confirmPassword, accessToken: $accessToken}){
            msg
            statusCode
        }
    }
`;

export const USER_DETAILS = gql`
    query userDetails($logonId: String!) {
        user(input: {
            logonId: $logonId
        }){
            firstName
        }
    }
`;
